import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import CandidateRatingFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/CandidateRatingFilter'
import CandidateStatusFilter from './statusFilter'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Users/Partials/UsersFilter/Styles/style'
import React, { useState } from 'react'
const CandidateFilter = ({
  searchValue,
  setSearchValue,
  candidateRating,
  setCandidateRating,
  candidateStatus,
  setCandidateStatus,
  setCandidateFilterData,
  individualDrawerQuestion,
  candidateFilterData,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const submitFilter = () => {
    setIsMenuOpen(false)
    setCandidateFilterData({
      rating: candidateRating || '',
      status: candidateStatus?.[0] || '',
    })
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    setCandidateRating(candidateFilterData?.rating)
    setCandidateStatus([candidateFilterData?.status])
  }
  const menu = (
    <MenuFlex column>
      <StyledTab
        border={true}
        tabPosition={'left'}
        overflowX={'hidden'}
        type="card"
        padding="15px"
        items={[
          // {
          //   label: 'Rating',
          //   key: '1',
          //   children: (
          //     <CandidateRatingFilter
          //       candidateRating={candidateRating}
          //       setCandidateRating={setCandidateRating}
          //     />
          //   ),
          // },
          {
            label: 'Status',
            key: '2',
            children: (
              <CandidateStatusFilter
                candidateStatus={candidateStatus}
                setCandidateStatus={setCandidateStatus}
              />
            ),
          },
        ]}
      />
      <SubmitFlex right width={true}>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary text="Apply Filter" onClick={submitFilter} />
      </SubmitFlex>
    </MenuFlex>
  )
  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      CandidateFilter="false"
      currentCount={
        individualDrawerQuestion?.count < 10
          ? individualDrawerQuestion?.count
          : individualDrawerQuestion?.result?.length +
            individualDrawerQuestion?.page * 10
      }
      totalCount={individualDrawerQuestion?.count}
      onOpenChange={onCancelFilter}
    />
  )
}

export default CandidateFilter
